import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import CommonService from "app/data/common/commonService";
import { initialZipcodeLocationsState } from "./ZipcodeLocationsState";
import { LocationDataModel } from "app/data/common/models";

const commonService = CommonService.getInstance();

export const zipcodeLocationsSlice = createSlice({
  name: "zipcodeLocations",
  initialState: initialZipcodeLocationsState,
  reducers: {
    resetZipcodeLocations: (state) => initialZipcodeLocationsState,
    zipcodeLocationsLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    zipcodeLocationsLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.locations = [];
      state.locations.push(...payload.map((location: LocationDataModel) => {
        return {
          label: `${location.zip} - ${location.city}, ${location.state}`,
          value: {
            zip: location.zip,
            city: location.city,
            state: location.state,
            direct: location.direct
          },
          valueForSearch: `${location.zip} ${location.city}`
        }
      }));
    },
    zipcodeLocationsLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.locations = [];
    },
  },
});

export const {
  resetZipcodeLocations,
  zipcodeLocationsLoadingStarted,
  zipcodeLocationsLoadingSucceed,
  zipcodeLocationsLoadingFailed,
} = zipcodeLocationsSlice.actions;

export const zipcodeLocationsSelector = (state: IState) => state.zipcodeLocations;

export const searchZipcodeLocations = (
  query: string,
  onError?: (error: string | object | null) => void
): AppThunk => async (dispatch) => {
  dispatch(zipcodeLocationsLoadingStarted());
  const response = await commonService.searchLocations(query);
  if (response.ok()) {
    dispatch(zipcodeLocationsLoadingSucceed(response.data));
  } else {
    const error = response.getError ? response.getError() : "Internal Server Error, re-try the action or contact support";
    dispatch(zipcodeLocationsLoadingFailed());
    onError && onError(error)
  }
};

const zipcodeLocationsReducer = zipcodeLocationsSlice.reducer;
export default zipcodeLocationsReducer;
